/**
 * @template {import("@sentry/react-router").Event} T
 * @param {T} event
 * @returns {T}
 */
export function scrubSentryRequestCredentials(event) {
  const participation = /\/(?:api\/)?(?:events|plans)\/[^/]+\/(?:checkout-|purchase-|ticket-claim|tickets\/claim)/;
  const cleanURL = value => {
    if (typeof value !== "string") return value;
    try {
      const url = new URL(value, "https://butter.invalid");
      if (/\/tickets\/claim(?:\/|$)/.test(url.pathname)) { url.hash = ""; url.searchParams.delete("token"); }
      return value.startsWith("http") ? url.href : url.pathname + url.search + url.hash;
    } catch { return value; }
  };
  if (event.request) {
    if (participation.test(event.request.url ?? "")) delete event.request.data;
    event.request.url = cleanURL(event.request.url);
    delete event.request.cookies;
    for (const header of Object.keys(event.request.headers ?? {})) {
      if (/^(cookie|set-cookie|authorization|proxy-authorization)$/i.test(header)) {
        delete event.request.headers[header];
      }
    }
  }
  for (const breadcrumb of event.breadcrumbs ?? []) {
    if (!breadcrumb.data) continue;
    if (participation.test(breadcrumb.data.url ?? "")) {
      delete breadcrumb.data.body;
      delete breadcrumb.data.request_body;
      delete breadcrumb.data.response_body;
    }
    for (const key of ["url", "from", "to"]) if (key in breadcrumb.data) breadcrumb.data[key] = cleanURL(breadcrumb.data[key]);
  }
  return event;
}
